// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "visualization" + "." + "489fb704dbceb5724b2a" + ".js";
};